var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/search-normal_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6059 9.89575C16.0312 9.89575 9.89062 16.0363 9.89062 23.611C9.89062 31.1858 16.0312 37.3263 23.6059 37.3263C31.1806 37.3263 37.3212 31.1858 37.3212 23.611C37.3212 16.0363 31.1806 9.89575 23.6059 9.89575ZM6.76562 23.611C6.76562 14.3104 14.3053 6.77075 23.6059 6.77075C32.9065 6.77075 40.4462 14.3104 40.4462 23.611C40.4462 32.9117 32.9065 40.4513 23.6059 40.4513C14.3053 40.4513 6.76562 32.9117 6.76562 23.611Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.778 37.7841C38.3882 37.1739 39.3775 37.1739 39.9877 37.7841L42.7654 40.5618C43.3756 41.172 43.3756 42.1614 42.7654 42.7715C42.1553 43.3817 41.1659 43.3817 40.5557 42.7715L37.778 39.9938C37.1678 39.3836 37.1678 38.3943 37.778 37.7841Z",
    fill: "#0082CD"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBig);
export default __webpack_public_path__ + "static/media/search-big.9211ca6427d2d701b77c648afebdf014.svg";
export { ForwardRef as ReactComponent };